import {
  VALIDATE_DUPLICATE_DENOUNCES,
  VALIDATE_DUPLICATE_DENOUNCES_FULFILLED,
  VALIDATE_DUPLICATE_DENOUNCES_ERROR,
  VALIDATE_DUPLICATE_DENOUNCES_RESET,
} from "redux/actions/validateDuplicateDenounces";

const initialState = {
  isLoading: false,
  duplicates: [],
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case VALIDATE_DUPLICATE_DENOUNCES:
    return {
      ...state,
      isLoading: true,
      error: null,
    };

  case VALIDATE_DUPLICATE_DENOUNCES_FULFILLED:
    return {
      ...state,
      isLoading: false,
      duplicates: action.payload || [],
      error: null,
    };

  case VALIDATE_DUPLICATE_DENOUNCES_ERROR:
    return {
      ...state,
      isLoading: false,
      duplicates: [],
      error: action.payload.error,
    };

  case VALIDATE_DUPLICATE_DENOUNCES_RESET:
    return initialState;

  default:
    return state;
  }
};
